import { generateItems } from 'domain/common';
import { Sale } from 'domain/lib';

const { actions, selectors, reducer } = generateItems('Sale', Sale);

export { actions, selectors, reducer };
